import { Component, Input } from '@angular/core';
import { LeadTimelineComponent } from "../../leads/lead-timeline/lead-timeline.component";
import { LocalStorageService } from 'src/app/utils/LocalStorageService';
import { MessageService } from 'primeng/api';
import { LeadService } from 'src/app/private/services/lead.service';
import moment from 'moment';
import { CommonModule } from '@angular/common';
import { DialogModule } from 'primeng/dialog';
import { ProgressSpinnerModule } from 'primeng/progressspinner';
import { UploadDocumentsComponent } from '../../registration/upload-documents/upload-documents.component';

@Component({
  selector: 'app-update-student-document',
  imports: [LeadTimelineComponent, CommonModule, DialogModule, ProgressSpinnerModule, UploadDocumentsComponent],
  templateUrl: './update-student-document.component.html',
  styleUrl: './update-student-document.component.scss'
})
export class UpdateStudentDocumentComponent {

  lead_id: string = '';
  @Input() studentDetails: any = {};
  leadDocuments: any[] = [];
  loading: boolean = false;
  isUploadDocument: boolean = false;

  constructor(private api: LeadService, private localStorage: LocalStorageService, private messageService: MessageService) { }

  ngOnInit() {
    this.lead_id = this.studentDetails.lead_id;
    console.log('Lead ID:', this.lead_id);
    this.getDocumentData();
  }


  getDocumentData() {
    this.loading = true;
    const payload = {
      "organization_id": this.localStorage.getOrganizationId(),
      "lead_id": this.lead_id
    }
    this.api.getLeadDocuments(payload).subscribe({
      next: data => {
        this.loading = false;
        this.leadDocuments = data;

        this.leadDocuments = this.leadDocuments.map((document: any) => {
          return {
            name: document?.document_category,
            date: moment(document?.updatedAt).format('DD/MM/YYYY HH:mm'),
            desc: '',
            id: document?.id,
            document_url: document?.document_url,
            document_type: 'document_preview',
            restData: document
          }
        })

        // this.documentService.setDocuments(this.leadDocuments);
      },
      error: error => {
        this.loading = false;
        this.messageService.add({ severity: 'error', summary: 'Error', detail: 'Failed to get documents' });
      }
    }
    )
  }

  handleDialogClose() {
    this.isUploadDocument = false;
    this.getDocumentData();
  }
}
